export function findUnique(arrayOfObjects, key) {
  return [...new Set(arrayOfObjects.filter(item => !!item[key]).map(item => item[key]))];
}

export function removeDuplicates(array) {
  return [...new Set(array)];
}
